import { render, staticRenderFns } from "./LogosCarousel.vue?vue&type=template&id=591f3995&scoped=true&"
import script from "./LogosCarousel.vue?vue&type=script&lang=js&"
export * from "./LogosCarousel.vue?vue&type=script&lang=js&"
import style0 from "./LogosCarousel.vue?vue&type=style&index=0&id=591f3995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591f3995",
  null
  
)

export default component.exports